import { EMPTY_STRING } from '../../constants/common'
import { PROFILE_ROUTE_NAMES } from '../../constants/route'

import {
  APPLICANT_CREDIT_CHECK_BAND_LABEL_KEY,
  APPLICANT_CREDIT_CHECK_BAND_TEXT_COLOR,
  APPLICANT_MASKED_TEXT_COLOR,
  APPLICANT_PROFILE_BLOCK,
  APPLICANT_PROFILE_BLOCK_PARAM,
} from './RentalPortalApplicant.constants'

export function getIsApplicantFieldMasked(field) {
  return field?.masked !== false
}

export function getApplicantFieldValue(field) {
  return getIsApplicantFieldMasked(field) ? null : (field?.value ?? null)
}

export function getApplicantMaskedFieldText({ emptyKey, field, maskedKey, t }) {
  if (getIsApplicantFieldMasked(field)) {
    return t(maskedKey)
  }

  return field.value || (emptyKey ? t(emptyKey) : EMPTY_STRING)
}

export function getApplicantCreditCheckBandProps({ field, t }) {
  const band = getApplicantFieldValue(field)

  return {
    text: t(
      APPLICANT_CREDIT_CHECK_BAND_LABEL_KEY[band] ??
        'RentalPortal.ApplicantProfileMaskedValueKey'
    ),
    textColor:
      APPLICANT_CREDIT_CHECK_BAND_TEXT_COLOR[band] ??
      APPLICANT_MASKED_TEXT_COLOR,
  }
}

export function getApplicantFormOptionalLabel({ label, t }) {
  return `${t('RentalPortal.FormOptionalFieldLabelKey', { label })}:`
}

export function toApplicantHouseholdSizeSelectItems({ sizes, t }) {
  return sizes.map(size => ({
    label: t('RentalPortal.ApplicantFormHouseholdSizeOptionKey', {
      count: size,
    }),
    value: size,
  }))
}

export function getApplicantProfileLink(id) {
  return PROFILE_ROUTE_NAMES.rentalPortalApplicantProfile({ id })
}

export function getApplicantProfileDecisionLink(id) {
  return `${getApplicantProfileLink(id)}?${APPLICANT_PROFILE_BLOCK_PARAM}=${APPLICANT_PROFILE_BLOCK.decision}`
}
